import { Header, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { AuditLogListPresenter } from '@webapp/platform/audit-log'
import messages from '../messages'

export interface IAuditLogTabContentProps {
  expenseContentTypeId: number
  expenseId: string
}

export const AuditLogTabContent = ({
  expenseContentTypeId,
  expenseId,
}: IAuditLogTabContentProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space size='large'>
      <Header as='h4'>{intl.formatMessage(messages.auditLogHeading)}</Header>
      <AuditLogListPresenter
        objectId={expenseId}
        contentTypeId={expenseContentTypeId}
      />
    </Space>
  )
}
